import React, { useState } from 'react';
import { PREPAGO_PLANS, PrepagoPlan, formatCOP } from '../../payments/plans';
import type { PlanPrices } from '../paidSignupApi';
import { linkButtonClass } from '../constants';

const priceLabel = (
    prices: PlanPrices | null,
    plan: PrepagoPlan,
    formatAmount: (value: number) => string,
): string => {
    const price = prices?.[plan.id];
    return price === undefined ? '—' : formatAmount(price);
};

export const PlanSummary: React.FC<{
    plan: PrepagoPlan;
    /** Backend prices; `null` while loading. */
    prices: PlanPrices | null;
    onChange: (plan: PrepagoPlan) => void;
    disabled: boolean;
    formatAmount?: (value: number) => string;
}> = ({ plan, prices, onChange, disabled, formatAmount = formatCOP }) => {
    const [choosing, setChoosing] = useState(false);

    return (
        <div className={`rounded-2xl border ${plan.border} ${plan.cardBg} p-5`}>
            <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-3">
                    <div className={`w-10 h-10 ${plan.iconBg} ${plan.textColor} rounded-xl flex items-center justify-center shrink-0`}>
                        {plan.icon}
                    </div>
                    <div>
                        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Tu plan</p>
                        <p className="font-bold text-lg text-slate-900">Plan {plan.name}</p>
                    </div>
                </div>
                <button
                    type="button"
                    onClick={() => setChoosing(v => !v)}
                    disabled={disabled}
                    className={`text-xs ${linkButtonClass}`}
                >
                    {choosing ? 'Cerrar' : 'Cambiar plan'}
                </button>
            </div>

            <div className="mt-3 flex items-baseline gap-1">
                <span className="text-3xl font-extrabold text-slate-900">{priceLabel(prices, plan, formatAmount)}</span>
                <span className="text-slate-500 text-sm font-medium">/mes</span>
            </div>
            <p className="mt-1 text-sm font-medium text-slate-600">
                {plan.messages.toLocaleString('es-CO')} recordatorios automáticos incluidos
            </p>

            {choosing && (
                <div className="mt-4 grid gap-2">
                    {PREPAGO_PLANS.map(option => (
                        <button
                            key={option.id}
                            type="button"
                            onClick={() => {
                                onChange(option);
                                setChoosing(false);
                            }}
                            className={`flex items-center justify-between rounded-xl border px-4 py-3 text-left text-sm transition-all bg-white ${
                                option.id === plan.id ? 'border-[#1CB3B3] ring-2 ring-[#1CB3B3]/20' : 'border-slate-200 hover:border-slate-300'
                            }`}
                        >
                            <span className="font-semibold text-slate-900">
                                {option.name}
                                <span className="font-normal text-slate-500"> · {option.messages.toLocaleString('es-CO')} recordatorios</span>
                            </span>
                            <span className="font-bold text-slate-900">{priceLabel(prices, option, formatAmount)}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};
